<template>
  <div class="import-box">
    <search-box class="search-box">
      <el-form :model="searchForm" ref="searchForm" :inline="true" size="mini">
        <el-form-item label="产品编码：" prop="pcode">
          <el-input v-model="searchForm.pcode" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="产品名称：" prop="name">
          <el-select
            size="mini"
            v-model="searchForm.name"
            placeholder="请输入产品名称"
            filterable
            remote
            reserve-keyword
            :remote-method="(val) => remoteMethod(val, 'productNameList', 1)"
            :loading="selectLoading"
            clearable
          >
            <el-option v-for="item in productNameList" :key="item.id" :label="item.name" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品型号：" prop="modelName">
          <el-select
            size="mini"
            v-model="searchForm.modelName"
            placeholder="请输入产品型号"
            filterable
            remote
            reserve-keyword
            :remote-method="(val) => remoteMethod(val, 'modelNameList', 2)"
            :loading="selectLoading"
            clearable
          >
            <el-option v-for="item in modelNameList" :key="item.id" :label="item.modelName" :value="item.modelName"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
      </template>
    </search-box>
    <div class="content-box">
      <div class="tips">请先筛选产品,然后进行图片上传</div>
      <div class="title-box">
        <div class="title">产品信息</div>
        <div class="orange-text-btn">状态：{{ formData.checkStatusStr }}</div>
      </div>
      <el-card shadow="hover">
        <div class="message-box">
          <div>产品编码：{{ pcode }}</div>
          <div>产品名称：{{ formData.name }}</div>
          <div>产品型号： {{ formData.modelName }}</div>
          <div>
            投产新品变更时间： <span :class="errorText && 'red-text-btn'">{{ timeTips(formData.productionTime) }}</span>
          </div>
        </div>
      </el-card>
      <div class="img-box">
        <div class="vision-box">
          <div class="title-box">
            <div class="title">视觉拍样图</div>
            <div><el-button type="text" @click="rollbackRecord(1)">回退记录</el-button></div>
          </div>
          <el-card shadow="hover">
            <div class="upload-box">
              <el-form :model="visionForm" ref="visionForm" :rules="visionRules" label-position="left" size="mini">
                <el-form-item
                  label="视觉拍摄原图："
                  label-width="100%"
                  prop="visionImg"
                  :class="`import-item ${(isImportVision || !isShowVisionImport) && 'visionDisabled'} ${visionFileList.length == 6 && 'hiddenImport'}`"
                >
                  <el-upload
                    ref="drivePics"
                    accept=".jpg,.jpeg,.png"
                    action=""
                    list-type="picture-card"
                    :limit="6"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="visionHandleRemove"
                    :on-change="visionChange"
                    :http-request="visionSuccess"
                    :file-list="visionFileList"
                    v-if="pcode"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
                <template v-if="isImportVision">
                  <el-form-item label="上传人：" label-width="100px">
                    {{ formData.viewUploaderName }}
                  </el-form-item>
                  <el-form-item label="上传时间：" label-width="100px">
                    {{ formData.viewUploadTime }}
                  </el-form-item>
                </template>
                <el-form-item
                  label="视觉拍摄补充原图："
                  label-width="100%"
                  prop="supplyImg"
                  v-show="isImportVision && (!isImportFirstSet || isImportSupply)"
                  :class="`import-item item-top ${(isImportSupply || !isShowVisionImport) && 'visionDisabled'} ${supplyFileList.length == 6 && 'hiddenImport'}`"
                >
                  <el-upload
                    ref="drivePics"
                    accept=".jpg,.jpeg,.png"
                    action=""
                    list-type="picture-card"
                    :limit="6"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="supplyHandleRemove"
                    :on-change="supplyChange"
                    :http-request="supplySuccess"
                    :file-list="supplyFileList"
                    v-if="pcode"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
                <template v-if="isImportSupply">
                  <el-form-item label="上传人：" label-width="100px">
                    {{ formData.supplementUploader }}
                  </el-form-item>
                  <el-form-item label="上传时间：" label-width="100px">
                    {{ formData.supplementUploadTime }}
                  </el-form-item>
                </template>
              </el-form>
              <div class="footer">
                <template>
                  <el-button class="green-btn" size="mini" @click="visionUpload" v-if="!isImportVision && pcode && isShowVisionImport">上传</el-button>
                  <el-button
                    class="green-btn"
                    size="mini"
                    @click="supplyUpload"
                    v-if="!isImportSupply && pcode && isShowVisionImport && isImportVision && !isImportFirstSet"
                    >补充上传</el-button
                  >
                  <el-button class="red-btn" size="mini" @click="fallback(1)" v-if="isVisionRollback">回退</el-button>
                </template>
              </div>
            </div>
          </el-card>
          <div class="atypism-box" v-if="status > 5">
            <div class="title-box">
              <div class="title">不一致处理</div>
            </div>
            <el-card shadow="hover">
              <el-form :model="atypismForm" ref="atypismForm" :rules="atypismRules" label-position="left" size="mini">
                <el-form-item label="处理结果：" label-width="120px" prop="handleFlag" class="item-bottom">
                  <el-radio-group v-model="atypismForm.handleFlag" v-if="!formData.handleFlag">
                    <el-radio :label="1">视觉P图</el-radio>
                    <el-radio :label="2">重新打样</el-radio>
                  </el-radio-group>
                  <span v-else>{{ formData.handleFlagStr }}</span>
                </el-form-item>
                <template v-if="formData.handleTime">
                  <el-form-item label="处理人：" label-width="100px">
                    {{ formData.handlerName }}
                  </el-form-item>
                  <el-form-item label="处理时间：" label-width="100px">
                    {{ formData.handleTime }}
                  </el-form-item>
                </template>
              </el-form>
              <div class="footer" v-if="!formData.handleTime && isShowAtypismHandle">
                <el-button class="green-btn" size="mini" @click="atypismSubmit">提交</el-button>
              </div>
            </el-card>
          </div>
        </div>
        <div class="firstSet-box">
          <div class="title-box">
            <div class="title">首套试制图</div>
            <div><el-button type="text" @click="rollbackRecord(2)">回退记录</el-button></div>
          </div>
          <el-card shadow="hover">
            <div class="upload-box">
              <el-form :model="firstSetForm" ref="firstSetForm" :rules="firstSetRules" label-position="left" size="mini">
                <el-form-item
                  label="正面图片："
                  label-width="100%"
                  prop="positiveImg"
                  :class="`import-item ${(isImportFirstSet || !isShowFirstSetImport) && 'firstSetDisabled'} ${positiveFileList.length == 6 && 'hiddenImport'}`"
                >
                  <el-upload
                    ref="drivePics"
                    accept=".jpg,.jpeg,.png"
                    action=""
                    list-type="picture-card"
                    :limit="6"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="positiveHandleRemove"
                    :on-change="positiveChange"
                    :http-request="positiveSuccess"
                    :file-list="positiveFileList"
                    v-if="pcode"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div class="noneBox" v-else></div>
                </el-form-item>
                <el-form-item
                  label="背面图片："
                  label-width="100%"
                  prop="backImg"
                  :class="`import-item ${(isImportFirstSet || !isShowFirstSetImport) && 'firstSetDisabled'} ${backFileList.length == 6 && 'hiddenImport'}`"
                >
                  <el-upload
                    ref="drivePics"
                    accept=".jpg,.jpeg,.png"
                    action=""
                    list-type="picture-card"
                    :limit="6"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="backHandleRemove"
                    :on-change="backChange"
                    :http-request="backSuccess"
                    :file-list="backFileList"
                    v-if="pcode"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div class="noneBox" v-else></div>
                </el-form-item>
                <el-form-item
                  label="其他补充图片："
                  label-width="100%"
                  prop="otherImg"
                  :class="`import-item ${(isImportFirstSet || !isShowFirstSetImport) && 'firstSetDisabled'} ${otherFileList.length == 6 && 'hiddenImport'}`"
                >
                  <el-upload
                    ref="drivePics"
                    accept=".jpg,.jpeg,.png"
                    action=""
                    list-type="picture-card"
                    :limit="6"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="otherHandleRemove"
                    :on-change="otherChange"
                    :http-request="otherSuccess"
                    :file-list="otherFileList"
                    v-if="pcode"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div class="noneBox" v-else></div>
                </el-form-item>
                <el-form-item label="首套是否与拍样一致：" label-width="165px" prop="sameFlag" class="item-bottom" v-if="isImportVision">
                  <el-radio-group v-model="firstSetForm.sameFlag" v-if="!isImportFirstSet">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="2">否</el-radio>
                  </el-radio-group>
                  <span v-else>{{ sameFlagText[formData.sameFlag - 1] }}</span>
                </el-form-item>
                <el-form-item label="不一致原因：" label-width="160px" class="item-bottom" prop="diffReason" v-if="firstSetForm.sameFlag === 2 || status > 5">
                  <el-input v-model="firstSetForm.diffReason" type="textarea" resize="none" v-if="!isImportFirstSet"></el-input>
                  <span v-else>{{ formData.diffReason }}</span>
                </el-form-item>
                <template v-if="isImportFirstSet">
                  <el-form-item label="上传人：" label-width="100px">
                    {{ formData.firstUploaderName }}
                  </el-form-item>
                  <el-form-item label="上传时间：" label-width="100px">
                    {{ formData.firstUploadTime }}
                  </el-form-item>
                </template>
              </el-form>
              <div class="footer">
                <el-button class="green-btn" size="mini" @click="firstSetUpload" v-if="!isImportFirstSet && pcode && isShowFirstSetImport">上传</el-button>
                <el-button class="red-btn" size="mini" @click="fallback(2)" v-if="isFirstSetRollback">回退</el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 图片查看 -->
    <el-dialog :visible.sync="dialogVisible" title="预览" width="550px">
      <el-image style="width: 500px; height: 500px" :src="dialogImageUrl" fit="cover"></el-image>
    </el-dialog>
    <!-- 回退记录 -->
    <rollback-record :visible.sync="isShowRollbackRecord" v-if="isShowRollbackRecord" :recordForm="recordForm" />
  </div>
</template>

<script>
import moment from 'moment';
import rollbackRecord from './components/rollback-record-dialog.vue';
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'ImgImport',
  mixins: [tableMixin],
  components: { rollbackRecord, pagePathMixin },
  data() {
    return {
      loading: false,
      recordForm: false,
      imgFormVisible: false,
      isShowOmparison: false,
      isShowVisionImg: false,
      dialogVisible: false,
      isShowRollbackRecord: false,
      selectLoading: false,
      errorText: false,
      searchForm: {
        pcode: '',
        name: '',
        modelName: '',
      },
      formData: {},
      visionForm: {
        visionImg: [],
        supplyImg: [],
      },
      firstSetForm: {
        positiveImg: [],
        backImg: [],
        sameFlag: '',
        otherImg: [],
        diffReason: '',
      },
      atypismForm: {
        handleFlag: '',
      },
      visionRules: {
        visionImg: [{ required: true, message: '请上传视觉拍摄图片', trigger: 'change' }],
      },
      firstSetRules: {
        positiveImg: [{ required: true, message: '请上传正面图片', trigger: 'change' }],
        backImg: [{ required: true, message: '请上传背面图片', trigger: 'change' }],
        sameFlag: [{ required: true, message: '不能为空', trigger: 'change' }],
        diffReason: [{ required: false, message: '不能为空', trigger: 'change' }],
      },
      atypismRules: {
        handleFlag: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      rowData: {},
      visionFileList: [],
      supplyFileList: [],
      positiveFileList: [],
      backFileList: [],
      otherFileList: [],
      productNameList: [],
      modelNameList: [],
      dialogImageUrl: '',
      sameFlagText: ['是', '否', '无需确认', '未确认'],
    };
  },
  computed: {
    pcode() {
      return this.formData.pcode;
    },
    //状态
    status() {
      // 状态，1：未上传，2：视觉已上传，3：首套已上传，4，已确认一致，5：已上传无需上传，6：不一致待处理，7：不一致已处理
      return this.formData.checkStatus;
    },
    //视觉是否上传
    isImportVision() {
      return this.formData.viewUploadRecordId;
    },
    //视觉-补充是否上传
    isImportSupply() {
      return this.formData.supplementUploader;
    },
    //首套是否上传
    isImportFirstSet() {
      return this.formData.firstUploadRecordId;
    },
    //视觉回退是否展示
    isVisionRollback() {
      //视觉上传 不一致处理状态
      const status = [2, 6];
      return (
        this.isImportVision &&
        this.isShowVisionImport &&
        this.formData.rollbackFlag != 1 &&
        this.formData.rollbackFlag != 3 &&
        status.includes(this.formData.checkStatus)
      );
    },
    //首套是否已经回退过
    isFirstSetRollback() {
      //首套上传 不一致处理状态
      const status = [3, 6];
      return (
        this.isImportFirstSet &&
        this.isShowFirstSetImport &&
        this.formData.rollbackFlag != 2 &&
        this.formData.rollbackFlag != 3 &&
        status.includes(this.formData.checkStatus)
      );
    },
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    //视觉上传权限
    isShowVisionImport() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$visionImport';
      return this.permitList.includes(Jurisdiction) && !this.errorText;
    },
    //首套上传权限
    isShowFirstSetImport() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$firstSetImport';
      return this.permitList.includes(Jurisdiction) && !this.errorText && !this.formData.tempProduct;
    },
    //不一致处理权限
    isShowAtypismHandle() {
      let Jurisdiction = 'ec-pc-new$productLifeCycle$aboutNew$SamplePicturesImport$atypismHandle';
      return this.permitList.includes(Jurisdiction) && !this.errorText;
    },
  },
  watch: {
    $route: {
      handler(val, olv) {
        if (
          olv.path == '/newProduct/samplePicturesImport' &&
          (val.query.pCode != this.searchForm.pcode || val.query.name != this.searchForm.name || val.qeury.modelName != this.searchForm.modelName) &&
          JSON.stringify(val.query) != '{}'
        ) {
          if (!val.query.pCode) {
            this.$router.replace({ path: '/newProduct/imgImport', query: {} });
            this.onReset();
            return;
          }
          this.restImg();
          this.$set(this.searchForm, 'pcode', val.query.pCode);
          this.init();
        }
      },
    },
  },
  mounted() {
    let query = this.$route.query;
    query.pCode && this.$set(this.searchForm, 'pcode', query.pCode);
    query.pCode && this.init();
  },
  methods: {
    remoteMethod(query, key, type) {
      if (query !== '' && query.length > 4) {
        this.selectLoading = true;
        this.$q.newProduct
          .filterProductData({
            data: {
              keyword: query,
              queryFlag: type,
            },
          })
          .then((res) => {
            if (res.data.length) {
              this[key] = res.data;
            } else {
              this[key] = [];
            }
          })
          .finally((_) => {
            this.selectLoading = false;
          });
      } else {
        this[key] = [];
      }
    },
    onSearch() {
      this.restImg();
      this.init();
    },
    onReset() {
      this.$refs.searchForm.resetFields();
      this.restImg();
    },
    restImg() {
      this.formData = {};
      this.firstSetForm = {
        positiveImg: [],
        backImg: [],
        sameFlag: '',
        otherImg: [],
        diffReason: '',
      };
      this.visionForm = {
        visionImg: [],
        supplyImg: [],
      };
      this.visionFileList = [];
      this.supplyFileList = [];
      this.positiveFileList = [];
      this.backFileList = [];
      this.otherFileList = [];
      this.$nextTick(() => {
        this.$refs.firstSetForm.clearValidate('sameFlag');
      });
    },
    init() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)',
      });
      this.$q.newProduct.productImgPreCheck({ data: this.searchForm }).then((res) => {
        this.formData = res.data || {};
        this.firstSetForm.diffReason = this.formData.diffReason;
        this.firstSetForm.sameFlag = this.formData.sameFlag;
        this.atypismForm.handleFlag = this.formData.handleFlag;
        this.$nextTick(() => {
          this.$refs.firstSetForm.clearValidate('sameFlag');
        });
        if (!this.isImportVision && !this.isImportFirstSet) {
          this.loading.close();
        }
        this.getVisionImg();
        this.getFirstSetImg();
      });
    },
    //获取视觉图回显
    getVisionImg() {
      let id = this.formData.viewUploadRecordId;
      if (!id) return;
      this.$q.newProduct
        .productCheckImgViewUploadImg({ fragment: [id] })
        .then((res) => {
          //视觉包括 视觉拍摄 和 补充拍摄 type都为1 通过supplement区分
          let imgList = res.data.filter((v) => v.dataType == 1);
          let visionImg = this.supplFilter(imgList, 0);
          let supplyImg = this.supplFilter(imgList, 1);
          this.visionFileList = this.formatImg(visionImg);
          this.supplyFileList = this.formatImg(supplyImg);
          this.visionForm.visionImg = visionImg;
          this.visionForm.supplyImg = supplyImg;
        })
        .finally((_) => {
          this.loading.close();
        });
    },
    //获取首套图回显
    getFirstSetImg() {
      let id = this.formData.firstUploadRecordId;
      if (!id) return;
      this.$q.newProduct
        .productCheckImgViewUploadImg({ fragment: [id] })
        .then((res) => {
          this.firstSetForm.positiveImg = this.imgFilter(res.data, 2);
          this.firstSetForm.backFileImg = this.imgFilter(res.data, 3);
          this.firstSetForm.otherFileImg = this.imgFilter(res.data, 4);
          this.positiveFileList = this.formatImg(this.firstSetForm.positiveImg);
          this.backFileList = this.formatImg(this.firstSetForm.backFileImg);
          this.otherFileList = this.formatImg(this.firstSetForm.otherFileImg);
        })
        .finally((_) => {
          this.loading.close();
        });
    },
    imgFilter(list, type) {
      const imgList = list.find((v) => v.dataType == type);
      return imgList ? imgList.imgUrls : [];
    },
    supplFilter(list, type) {
      const imgList = list.find((v) => v.supplement == type);
      return imgList ? imgList.imgUrls : [];
    },
    formatImg(list) {
      const imgList = list.map((v) => {
        return {
          name: v.split('/').pop(),
          url: v,
        };
      });
      return imgList;
    },
    //视觉拍样图上传
    visionSuccess(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.visionForm.visionImg.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        this.$refs.visionForm.validateField('visionImg', (err) => {
          return false;
        });
      });
    },
    //视觉拍样图获取url
    visionChange(file) {
      this.visionFileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //视觉拍样图删除
    visionHandleRemove(file, fileList) {
      const index = this.visionFileList.findIndex((item) => item.url === file.url);
      this.visionForm.supplyImg.splice(index, 1);
      this.visionFileList.splice(index, 1);
    },

    //视觉拍样-补充图上传
    supplySuccess(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.visionForm.supplyImg.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        this.$refs.visionForm.validateField('visionImg', (err) => {
          return false;
        });
      });
    },
    //视觉拍样-补充图获取url
    supplyChange(file) {
      this.supplyFileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //视觉拍样-补充图删除
    supplyHandleRemove(file, fileList) {
      const index = this.supplyFileList.findIndex((item) => item.url === file.url);
      this.visionForm.visionImg.splice(index, 1);
      this.supplyFileList.splice(index, 1);
    },

    //正面图上传
    positiveSuccess(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.firstSetForm.positiveImg.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        this.$refs.firstSetForm.validateField('positiveImg', (err) => {
          return false;
        });
      });
    },
    //正面图获取url
    positiveChange(file) {
      this.positiveFileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //正面图删除
    positiveHandleRemove(file, fileList) {
      const index = this.positiveFileList.findIndex((item) => item.url === file.url);
      this.firstSetForm.positiveImg.splice(index, 1);
      this.positiveFileList.splice(index, 1);
    },
    //背面图上传
    backSuccess(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.firstSetForm.backImg.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        this.$refs.firstSetForm.validateField('backImg', (err) => {
          return false;
        });
      });
    },
    //背面图获取url
    backChange(file) {
      this.backFileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //背面图删除
    backHandleRemove(file, fileList) {
      const index = this.backFileList.findIndex((item) => item.url === file.url);
      this.firstSetForm.backImg.splice(index, 1);
      this.backFileList.splice(index, 1);
    },
    //其他补充图上传
    otherSuccess(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.firstSetForm.otherImg.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        this.$refs.firstSetForm.validateField('otherImg', (err) => {
          return false;
        });
      });
    },
    //其他补充图获取url
    otherChange(file) {
      this.otherFileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //其他补充图删除
    otherHandleRemove(file, fileList) {
      const index = this.otherFileList.findIndex((item) => item.url === file.url);
      this.firstSetForm.otherImg.splice(index, 1);
      this.otherFileList.splice(index, 1);
    },
    //图片预览
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 视觉拍样图上传
    visionUpload() {
      this.$refs.visionForm.validate((valid) => {
        if (!valid) return;
        let data = {
          dataCategory: 1,
          imgList: [
            {
              imgUrls: this.visionForm.visionImg,
              dataType: 1,
            },
          ],
          pcode: this.pcode,
        };
        this.$q.newProduct.productCheckImgSubmitImgInfo({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success('上传成功');
            this.onSearch();
          } else {
            this.$message.fail(res.message);
          }
        });
      });
    },
    // 视觉拍样-补充图上传
    supplyUpload() {
      this.$refs.visionForm.validate((valid) => {
        if (!valid) return;
        let data = {
          imgList: this.visionForm.supplyImg,
          pcode: this.pcode,
        };
        this.$q.newProduct.supplementImgInfo({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success('上传成功');
            this.onSearch();
          } else {
            this.$message.fail(res.message);
          }
        });
      });
    },
    // 首套图上传
    firstSetUpload() {
      this.$refs.firstSetForm.validate((valid) => {
        if (!valid) return;
        let data = {
          dataCategory: 2,
          imgList: [
            {
              imgUrls: this.firstSetForm.positiveImg,
              dataType: 2,
            },
            {
              imgUrls: this.firstSetForm.backImg,
              dataType: 3,
            },
            {
              imgUrls: this.firstSetForm.otherImg,
              dataType: 4,
            },
          ],
          pcode: this.pcode,
          sameFlag: this.firstSetForm.sameFlag,
          diffReason: this.firstSetForm.diffReason,
        };
        this.$q.newProduct.productCheckImgSubmitImgInfo({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success('上传成功');
            this.onSearch();
          } else {
            this.$message.fail(res.message);
          }
        });
      });
    },
    //不一致处理
    atypismSubmit() {
      this.$refs.atypismForm.validate((valid) => {
        if (!valid) return;
        let data = {
          pcode: this.pcode,
          handleFlag: this.atypismForm.handleFlag,
        };
        this.$q.newProduct.productCheckImgHandleDiff({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success('提交成功');
            this.onSearch();
          } else {
            this.$message.fail(res.message);
          }
        });
      });
    },
    //回退
    async fallback(type) {
      let status = await this.$confirm('一个产品只可回退一次，回退后，将清空上传图片，可在“回退记录”中查看下载回退图片,', '回退提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let data = {
        dataCategory: type,
        pcode: this.pcode,
      };
      let res = await this.$q.newProduct.productCheckImgRollback({ data: data });
      if (res.success) {
        this.$message.success('回退成功');
        this.onSearch();
      } else {
        this.$message.fail(res.message);
      }
    },
    //回退记录
    rollbackRecord(type) {
      this.recordForm = {
        dataCategory: type,
        pcode: this.pcode,
      };
      this.isShowRollbackRecord = true;
    },
    //时间展示转换
    timeTips(val) {
      if(this.formData.tempProduct) {
        this.errorText = false
        return val
      }
      // let notTime = moment(val).isBefore(moment().subtract(3, 'months').format('YYYY-MM-DD HH:mm'));
      // let text = notTime ? val + '已超三个月,不可上传;' : val ? val : '无投产新品信息,不可上传;';
      let text = val ? val : '无投产新品信息,不可上传;';
      // this.errorText = notTime || !val;
      this.errorText = !val;
      return text;
    },
  },
};
</script>
<style lang="stylus" scoped>
.import-box {
  margin: 5px;
  background: #fff;
  height: calc(100vh - 106px);
  border-radius: 4px;
  padding: 15px;
}

.content-box {
  padding: 0 10px;
  height: calc(100% - 35px);
  overflow-y: auto;
}

.tips {
  font-size: 14px;
  margin: 10px 0 15px 0;
}

.title-box {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.title {
  font-size: 20px;
  font-weight: bold;
  font-family: PingFangSC;
}

.message-box {
  display: flex;
  align-items: center;

  div {
    flex: 1;
  }
}

.img-box {
  display: flex;
  height: 50vh;

  .vision-box {
    flex: 1;
    padding-right: 50px;
  }

  .firstSet-box {
    flex: 1;
  }
}

.upload-box {
  border-radius: 4px;
  min-height: 160px
}

.atypism-box {
  margin-top: 15px;
}

.footer {
  text-align: center;
  margin-top: 20px;
}

.red-text {
  color: red;
  margin-right: 4px;
}

.noneBox {
  height: 103px
}

.item-top {
  margin-top: 15px;
}

.visionDisabled >>> .el-upload--picture-card {
  display: none;
}
.visionDisabled >>> .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete{
  display: none;
}
.firstSetDisabled >>> .el-upload--picture-card {
  display: none;
}
.hiddenImport >>> .el-upload--picture-card {
  display: none;
}
.firstSetDisabled >>> .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete{
  display: none;
}

>>> .el-card {
  margin: 10px 0;
}

>>> .el-card__body {
  padding: 15px;
}

>>> .el-form-item__content {
  text-align: right;
}

.import-item >>> .el-form-item__content {
  margin-left: 0 !important;
  text-align: left;
}

.import-item, .item-bottom  {
  margin-bottom: 15px !important;
}


.item-bottom >>> .el-form-item__error {
  right: 0 !important;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 0px;
}

>>> .el-upload--picture-card {
  width: 88px;
  height: 88px;
  line-height: 98px;
}

>>> .el-upload-list--picture-card .el-upload-list__item {
  width: 88px;
  height: 88px;
}
</style>
